import store from '../../../store/index';
import ApiClient from '../../ApiClient/ApiClient';
import { optimizelyInstance, optimizelyUserId } from '../../optimizely';

function featureEnabled() {
  return optimizelyInstance.isFeatureEnabled('behavior_tracking_brazil_frontend', optimizelyUserId());
}

const endpoint = process.env.BEHAVIOR_TRACKING_URL;
let isLoaded = false;

// also
// event, properties, tags
function basePayload() {
  return {
    timestamp:          new Date().toISOString(),
    primary_identifier: String(store.get('account')?.account_id),
    context:            {
      device: {
        user_agent:    navigator.userAgent,
        screen_height: window.screen.height,
        screen_width:  window.screen.width,
        inner_width:   window.innerWidth,
        inner_height:  window.innerHeight,
      },
      referrer: document.referrer,
    },
    additional_identifiers: {
      session_id: store.get('rails_session_id'),
    },
    brand: 'simplic',
    url:   window.location.href,
    env:   process.env.NODE_ENV,
  };
}

async function sendOrStoreEvent(payload) {
  if (!store.get('isLoggedIn')) {
    await store.dispatch('behaviorTracking/storeEvent', payload);
    return;
  }
  await ApiClient.post(endpoint, payload);
}

export default function behaviorTrackingPlugin() {
  // return object for analytics to use
  return {
    name:       'behavior-tracking',
    initialize: () => {
      isLoaded = true;
    },
    page: async () => {
      if (!featureEnabled()) { return; }
      const payload = {
        ...basePayload(),
        event:      'page_view',
        properties: {
          url: window.location.href,
        },
      };
      await sendOrStoreEvent(payload);
    },
    track: async ({ payload }) => {
      if (!featureEnabled()) { return; }
      const postPayload = {
        ...basePayload(),
        ...payload,
      };
      await sendOrStoreEvent(postPayload);
    },
    loaded: () => isLoaded,
  };
}
